import {z} from 'zod';
import {CommerceOfferInput,CommerceOfferSchema} from './commerce-types.js';
import {MerchantDisputeSchema} from './merchant-dispute-types.js';
import {MerchantBlockerSchema} from './merchant-availability.js';
import {SubscriptionCheckoutInput} from './merchant-subscriptions-types.js';

const atomic=z.string().regex(/^\d+$/);
const categoryId=z.string().regex(/^category-[a-f0-9]{24}$/);
export const MerchantCardOfferInput=CommerceOfferInput.omit({assetId:true}).extend({product:z.literal('payments'),taxCategoryId:categoryId}).strict();
export const MerchantTaxCategorySchema=z.object({id:categoryId,name:z.string(),description:z.string()}).strict();
export const MerchantCardOptionsSchema=z.object({currency:z.literal('USD'),minSubtotal:atomic,maxSubtotal:atomic,
  categories:z.array(MerchantTaxCategorySchema)}).strict();
export const MerchantCardOrderSchema=z.object({id:z.uuid(),name:z.string(),state:z.string(),createdAt:z.iso.datetime(),expiresAt:z.iso.datetime(),
  subtotal:atomic,total:atomic,tax:atomic.nullable(),fee:atomic.nullable(),refunded:atomic,refundDue:atomic,
  disputes:MerchantDisputeSchema.array(),
  checkoutPath:z.string(),invoicePath:z.string().nullable(),error:z.unknown().nullable(),
}).strict();
export const MerchantOfferSchema=CommerceOfferSchema.extend({product:z.enum(['payments','crypto']),taxCategoryId:categoryId});
export const MerchantCardWorkspaceSchema=z.object({
  mode:z.literal('live'),enabled:z.boolean(),collectionPaused:z.boolean(),blockers:MerchantBlockerSchema.array(),feeBasisPoints:z.number().int().min(0).max(10000).nullable(),feeFixedMinor:z.number().int().nonnegative().nullable(),
  offers:MerchantOfferSchema.array(),
  orders:z.array(MerchantCardOrderSchema),hasMoreOffers:z.boolean(),hasMoreOrders:z.boolean(),
}).strict();
export const MerchantCardCreatedSchema=z.object({mode:z.literal('live'),id:z.uuid(),checkoutPath:z.string()}).strict();
export type MerchantCardOptions=z.infer<typeof MerchantCardOptionsSchema>;
export type MerchantCardWorkspace=z.infer<typeof MerchantCardWorkspaceSchema>;
export type MerchantCardOfferRequest=z.infer<typeof MerchantCardOfferInput>;
export const MerchantCardCheckoutSchema=z.object({
  mode:z.literal('live'),id:z.uuid(),name:z.string(),description:z.string(),serviceOwner:z.string(),
  seller:z.object({name:z.string(),registrationNumber:z.string(),address:z.string(),email:z.email()}).strict(),
  state:z.string(),subtotal:z.string().regex(/^\d+$/),total:z.string().regex(/^\d+$/),tax:z.string().regex(/^\d+$/).nullable(),
  currency:z.literal('USD'),expiresAt:z.iso.datetime(),paid:z.boolean(),
  refunded:atomic,refundDue:atomic,reviewRequired:z.boolean(),
  clientSecret:z.string().nullable(),publishableKey:z.string().nullable(),invoicePath:z.string().nullable(),
  interval:z.enum(['month','year']).optional(),subscriptionId:z.uuid().optional(),
  quantity:SubscriptionCheckoutInput.shape.quantity.optional(),unitAmountAtomic:atomic.optional(),
  returnUrl:SubscriptionCheckoutInput.shape.returnUrl.optional(),
  embedOrigins:z.array(z.url()).optional(),
  subscriptionStatus:z.string().optional(),cancelAtPeriodEnd:z.boolean().optional(),paidThrough:z.iso.datetime().nullable().optional(),
}).strict();
export type MerchantCardCheckout=z.infer<typeof MerchantCardCheckoutSchema>;
